'use client';

import { useRouter } from 'next/navigation';
import Logo from '../assets/Logo';

type ErrorPageProps = {
  locale: 'fr' | 'en';
  title: string;
  description: string;
  showBackButton?: boolean;
  showHomeButton?: boolean;
};

const texts = {
  fr: {
    back: 'Retour',
    home: 'Accueil',
  },
  en: {
    back: 'Go Back',
    home: 'Go Home',
  },
};

export default function ErrorPage({
  title,
  description,
  showBackButton = true,
  showHomeButton = true,
  locale = 'fr',
}: ErrorPageProps) {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  const handleGoHome = () => {
    router.push('/');
  };

  return (
    <div className="min-h-screen bg-el-grey-200 flex items-center justify-center p-4">
      <div className="bg-white rounded-4 shadow-hover p-8 max-w-md w-full text-center">
        {/* Elyope Logo */}
        <div className="flex justify-center mb-6">
          <Logo className="w-32 h-auto" />
        </div>

        <h1 className="text-24 font-bold text-el-grey-800 mb-3">{title}</h1>

        <p className="text-14 text-el-grey-600 mb-6 leading-relaxed">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showBackButton && (
            <button
              onClick={handleGoBack}
              className="button button-neutral px-6 py-2"
            >
              {texts[locale].back}
            </button>
          )}
          {showHomeButton && (
            <button
              onClick={handleGoHome}
              className="button button-primary px-6 py-2"
            >
              {texts[locale].home}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
